import { IconMoodCrazyHappy, IconWriting } from "@tabler/icons";
import { get_lottie_obj } from "../common/utils";
import AnalyticsTabs from "./AnalyticsTabs";

const TestAnalyticsMarks = ({ number = 57, other = 50 }) => {
    const diff = ((100 * (number - other)) / other).toFixed(1);
    // console.log("other", diff);
    return (
        <AnalyticsTabs
            title={"Overall Marks"}
            // TitleIcon={IconMoodCrazyHappy}
            AnimateIcon={get_lottie_obj({
                datakey: "happy",
                width: 40,
                top: -10,
                left: "calc(100% - 30px)",
                position: "absolute",
            })}
            number={number}
            num_suffix="%"
            diff={diff}
            diffprefix=""
            diffsuffix="%"
            description="Compared with overall average marks(%) of other aspirants"
        />
    );
};

export default TestAnalyticsMarks;
